import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";
import { PACKAGE_GROUPS, PREWEDDING } from "../../content/site";
import { http, apiError } from "../../lib/api";
import { Input } from "../ui/input";

const SECTIONS = [
  ...PACKAGE_GROUPS.map((g) => ({ title: g.title, rows: g.tiers.map((t) => ({ key: t.key, label: t.tier, price: t.price })) })),
  { title: PREWEDDING.title, rows: PREWEDDING.plans.flatMap((p) => p.options.map((o) => ({ key: o.key, label: `${p.name} · ${o.label}`, price: o.price }))) },
];
const DEFAULTS = Object.fromEntries(SECTIONS.flatMap((s) => s.rows.map((r) => [r.key, r.price])));

export const PricesPanel = () => {
  const [prices, setPrices] = useState(DEFAULTS);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    http.get("/packages/prices").then((r) => setPrices((p) => ({ ...p, ...(r.data || {}) }))).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const payload = Object.fromEntries(Object.entries(prices).map(([k, v]) => [k, parseInt(v, 10) || 0]));
      await http.put("/packages/prices", { prices: payload });
      toast.success("Prices updated on the website");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="prices-panel">
      <div className="grid gap-6 md:grid-cols-3">
        {SECTIONS.map((s) => (
          <div key={s.title} className="rounded-2xl border border-gold/20 bg-white p-5">
            <p className="font-serif text-xl text-ink">{s.title}</p>
            <div className="mt-4 space-y-3">
              {s.rows.map((r) => (
                <label key={r.key} className="block">
                  <span className="text-[11px] uppercase tracking-[0.2em] text-ink-soft">{r.label}</span>
                  <div className="mt-1 flex items-center gap-2">
                    <span className="text-gold">₹</span>
                    <Input type="number" min={0} value={prices[r.key]} onChange={(e) => setPrices((p) => ({ ...p, [r.key]: e.target.value }))} className="h-11 rounded-xl" data-testid={`price-input-${r.key}`} />
                  </div>
                </label>
              ))}
            </div>
          </div>
        ))}
      </div>
      <button onClick={save} disabled={saving} className="btn-gold mt-8" data-testid="prices-save-btn">
        {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Save prices
      </button>
    </div>
  );
};
